export default {
  // Navigation
  'nav.timer': 'Таймер',
  'nav.stopwatch': 'Секундомер',
  'nav.worldclock': 'Мировые часы',
  'nav.timestamp': 'Временная метка',
  'nav.home': 'Главная',

  // Common buttons and actions
  'button.start': 'Начать',
  'button.pause': 'Пауза',
  'button.stop': 'Стоп',
  'button.reset': 'Сброс',
  'button.ok': 'ОК',
  'button.cancel': 'Отмена',
  'button.close': 'Закрыть',
  'button.save': 'Сохранить',
  'button.delete': 'Удалить',
  'button.edit': 'Редактировать',
  'button.back': 'Назад',
  'button.next': 'Далее',
  'button.previous': 'Предыдущий',
  'button.submit': 'Отправить',
  'button.confirm': 'Подтвердить',
  'button.convert': 'Преобразовать',
  'button.copy': 'Копировать',
  'button.copied': 'Скопировано!',
  'button.now': 'Сейчас',
  'button.clear': 'Очистить',

  // Common labels
  'label.hours': 'Часы',
  'label.minutes': 'Минуты',
  'label.seconds': 'Секунды',
  'label.milliseconds': 'Миллисекунды',
  'label.minute': 'Минута',
  'label.second': 'Секунда',
  'label.sound': 'Звук',
  'label.soundAlert': 'Звук',
  'label.fullscreen': 'Полный экран',
  'label.language': 'Язык',
  'label.selectLanguage': 'Выберите язык',
  'label.languageSelectorInfo': 'В настоящее время поддерживается {{count}} языков. Выберите предпочитаемый язык из вариантов выше.',

  // Common messages
  'message.timerComplete': 'Таймер завершен!',
  'message.timerCompleteDesc': 'Ваш таймер завершен',
  'message.timerCompleteBody': 'Ваш обратный отсчет завершен!',
  'message.stopwatchStarted': 'Секундомер запущен',
  'message.stopwatchStartedDesc': 'Отсчет секундомера начался',
  'message.stopwatchStopped': 'Секундомер остановлен',
  'message.stopwatchStoppedDesc': 'Отсчет секундомера приостановлен',
  'message.stopwatchReset': 'Секундомер сброшен',
  'message.stopwatchResetDesc': 'Секундомер сброшен на ноль',
  'message.notificationPermission': 'Разрешите уведомления, чтобы получать оповещения по окончании таймера',
  'message.clickToEdit': 'Нажмите на числа времени, чтобы редактировать время напрямую',
  'message.addHours': '+ Добавить часы',
  'message.escToExit': 'Нажмите ESC для выхода из полноэкранного режима',
  'message.timeRemaining': '{{minutes}} минут {{seconds}} секунд осталось',
  'message.minutesRemaining': '{{minutes}} минут осталось',
  'message.secondsRemaining': '{{seconds}} секунд осталось',
  'message.stopwatchTimeElapsed': 'Прошло {{minutes}} минут {{seconds}} секунд',
  'message.stopwatchMinutesElapsed': 'Прошло {{minutes}} минут',
  'message.stopwatchSecondsElapsed': 'Прошло {{seconds}} секунд',
  'message.invalidTimestamp': 'Неверная временная метка',
  'message.invalidDateTime': 'Неверные дата и время',
  'message.conversionError': 'Ошибка преобразования',

  // Time units
  'time.am': 'ДП',
  'time.pm': 'ПП',
  'time.now': 'Сейчас',
  'time.today': 'Сегодня',
  'time.yesterday': 'Вчера',
  'time.tomorrow': 'Завтра',

  // Common errors
  'error.pageNotFound': 'Страница не найдена',
  'error.somethingWrong': 'Что-то пошло не так',
  'error.tryAgain': 'Пожалуйста, попробуйте позже',

  // Footer
  'footer.about': 'О timer.today',
  'footer.aboutDesc': 'timer.today - это профессиональная платформа инструментов онлайн-учета времени, предоставляющая три основных функции:',
  'footer.timerDesc': 'Настраиваемый инструмент обратного отсчета с поддержкой настроек минут и часов, идеален для сосредоточения на работе, отсчета времени приготовления, управления учебой и многого другого. Имеет звуковые оповещения и уведомления на рабочем столе.',
  'footer.stopwatchDesc': 'Высокоточный инструмент учета времени с точностью до миллисекунды, подходит для спортивной подготовки, операций приготовления, практики экзаменов и других сценариев, требующих точного учета времени.',
  'footer.worldClockDesc': 'Отображение в реальном времени времени основных городов мира с интеллектуальными расчетами часовых поясов, облегчающими международное бизнес-общение и сотрудничество через часовые пояса.',
  'footer.timestampDesc': 'Конвертер временных меток Unix, поддерживающий двусторонний преобразование между временной меткой и датой/временем, с поддержкой форматов секунд и миллисекунд.',
  'footer.termsOfService': 'Условия использования',
  'footer.privacy': 'Конфиденциальность',
  'footer.contactUs': 'Свяжитесь с нами',
  'footer.changeLanguage': 'изменить язык',
  'footer.moreLanguage': 'больше языков',
  'footer.copyright': '© timer.today 2024',

  // Quick actions
  'quick.add30s': '+30 сек',
  'quick.add1min': '+1 мин',
  'quick.add5min': '+5 мин',
  'quick.add10min': '+10 мин',
  'quick.add30min': '+30 мин',

  // Breadcrumb
  'breadcrumb.minuteTimer': 'Таймер {{minutes}} минут',
  'breadcrumb.timer': 'Таймер',
  'breadcrumb.stopwatch': 'Секундомер',
  'breadcrumb.worldClock': 'Мировые часы',
  'breadcrumb.termsOfService': 'Условия использования',
};